import { INCOME_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
  getIncomeTypeLoading: false,
  getIncomeTypeSuccess: false,
  getIncomeTypeFailure: false,
  getIncomeTypeError: null,
  incomeTypes: [],
 
  addIncomeTypeLoading: false,
  addIncomeTypeSuccess: false,
  addIncomeTypeFailure: false,
  addIncomeTypeError: null
}

export const incomeTypeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INCOME_REQUEST.GET_INCOME_TYPE_REQUEST:
      return {
        ...state,
        getIncomeTypeLoading: true,
        getIncomeTypeSuccess: false,
        getIncomeTypeFailure: false,
        getIncomeTypeError: null,
      }
    case INCOME_REQUEST.GET_INCOME_TYPE_SUCCESS:
      return {
        ...state,
        getIncomeTypeLoading: false,
        getIncomeTypeSuccess: true,
        getIncomeTypeFailure: false,
        getIncomeTypeError: null,
        incomeTypes: action.payload
      }
    case INCOME_REQUEST.GET_INCOME_TYPE_FAILURE:
      return {
        ...state,
        getIncomeTypeLoading: false,
        getIncomeTypeSuccess: false,
        getIncomeTypeFailure: true,
        getIncomeTypeError: action.payload,
      }
    case INCOME_REQUEST.ADD_INCOME_TYPE_REQUEST:
      return {
        ...state,
        addIncomeTypeLoading: true,
        addIncomeTypeSuccess: false,
        addIncomeTypeFailure: false,
        addIncomeTypeError: null
      }
    case INCOME_REQUEST.ADD_INCOME_TYPE_SUCCESS:
      let newIncomeType = state.incomeTypes;
      newIncomeType.push(action.payload)
      return {
        ...state,
        addIncomeTypeLoading: false,
        addIncomeTypeSuccess: true,
        addIncomeTypeFailure: false,
        addIncomeTypeError: null,
        IncomeTypes: newIncomeType
      }
    case INCOME_REQUEST.ADD_INCOME_TYPE_FAILURE:
      return {
        ...state,
        addIncomeTypeLoading: false,
        addIncomeTypeSuccess: false,
        addIncomeTypeFailure: true,
        addIncomeTypeError: action.payload
      }
    case INCOME_REQUEST.DELETE_INCOME_TYPE_REQUEST:
      return {
        ...state,
        addIncomeTypeLoading: true,
        addIncomeTypeSuccess: false,
        addIncomeTypeFailure: false,
        addIncomeTypeError: null
      }
    case INCOME_REQUEST.DELETE_INCOME_TYPE_SUCCESS:
      let incomeType = state.incomeTypes;
      for (let i = 0; i < state.incomeTypes.length; i++) {
        if (incomeType[i].incomeTypeId === action.payload) {
          incomeType.splice(i, 1);
        }
      }
      return {
        ...state,
        addIncomeTypeLoading: false,
        addIncomeTypeSuccess: true,
        addIncomeTypeFailure: false,
        addIncomeTypeError: null,
        IncomeTypes: incomeType
      }
    case INCOME_REQUEST.DELETE_INCOME_TYPE_FAILURE:
      return {
        ...state,
        addIncomeTypeLoading: false,
        addIncomeTypeSuccess: false,
        addIncomeTypeFailure: true,
        addIncomeTypeError: action.payload
      }
    case INCOME_REQUEST.EDIT_INCOME_TYPE_REQUEST:
      return {
        ...state,
        addIncomeTypeLoading: true,
        addIncomeTypeSuccess: false,
        addIncomeTypeFailure: false,
        addIncomeTypeError: null
      }
    case INCOME_REQUEST.EDIT_INCOME_TYPE_SUCCESS:
      let incomeType_ = state.incomeTypes;
      for (let i = 0; i < state.incomeTypes.length; i++) {
        if (incomeType_[i].incomeTypeId === action.payload.incomeTypeId) {
          incomeType_[i] = action.payload
        }
      }
      return {
        ...state,
        addIncomeTypeLoading: false,
        addIncomeTypeSuccess: true,
        addIncomeTypeFailure: false,
        addIncomeTypeError: null,
        IncomeTypes: incomeType_
      }
    case INCOME_REQUEST.EDIT_INCOME_TYPE_FAILURE:
      return {
        ...state,
        addIncomeTypeLoading: false,
        addIncomeTypeSuccess: false,
        addIncomeTypeFailure: true,
        addIncomeTypeError: action.payload
      }
      default:
      return state;
  }
}